<template>
    <main>
        <div class="tab-header">
            <div class="container-fluid">
                <h4>保障分類設定</h4>
                <div class="mb-4 font-20">
                    <a 
                      v-if="$route.name === 'CoverageCategoryGroup'"
                      class="btn btn-default float-right fw-600" 
                      @click="openMidCategoryAddModal"
                    >
                      新增保障群組
                    </a>
                    <a 
                      v-if="$route.name === 'CoverageSpecialConditionGroup'" 
                      class="btn btn-default float-right fw-600" 
                      @click="openSpecialConditionAddModal"
                    >
                      新增特殊條件
                    </a>
                    <a 
                      v-if="$route.name === 'CoverageReportList'" 
                      class="btn btn-default float-right fw-600" 
                      @click="$router.push({ name: 'CoverageReportSearch' })"
                    >
                      保障群組對應保障設定查詢
                    </a>
                    <a 
                      v-if="$route.name === 'CoverageReportList'" 
                      class="btn btn-default float-right fw-600" 
                      @click="openReportAddModal"
                    >
                      新增保障設定
                    </a>
                </div>
                <ul class="nav nav-tabs">
                    <li class="nav-item" @click="$router.push({ name: 'CoverageCategoryGroup' })">
                        <a 
                          data-toggle="tab"
                          id="CoverageCategoryGroupLink"
                          class="nav-link show"
                          :class="{ active: $route.name === 'CoverageCategoryGroup' }"
                          >
                            保障群組管理
                          </a>
                    </li>
                    <li class="nav-item" @click="$router.push({ name: 'CoverageSpecialConditionGroup' })">
                        <a 
                          data-toggle="tab"
                          id="CoverageSpecialConditionGroupLink"
                          class="nav-link"
                          :class="{ active: $route.name === 'CoverageSpecialConditionGroup' }"
                          >
                            特殊條件管理
                          </a>
                    </li>
                    <li class="nav-item" @click="$router.push({ name: 'CoverageReportList' })">
                        <a 
                          data-toggle="tab"
                          id="CoverageReportListLink"
                          class="nav-link"
                          :class="{ active: $route.name === 'CoverageReportList' }"
                        >
                          保障內容設定
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content">
            <div class="container-fluid">
                <router-view :reload="reload"></router-view>
            </div>
        </div>
        <!--新增保障群組-->
        <MidCategoryAddModal
          v-if="$route.name === 'CoverageCategoryGroup'"
          :open="midCategoryAddModalOpen" 
          @close="closeMidCategoryAddModal"
          @reloadPage="reloadPage"> 
        </MidCategoryAddModal>
        <!--新增特殊條件-->
        <SpecialConditionAddModal
          v-if="$route.name === 'CoverageSpecialConditionGroup'"
          :open="specialConditionAddModalOpen" 
          @close="closeSpecialConditionAddModal"
          @confrim="reloadPage"> 
        </SpecialConditionAddModal>
        <!--新增保障設定-->
        <ReportAddModal
          v-if="$route.name === 'CoverageReportList'"
          :open="reportAddModalOpen" 
          @close="closeReportAddModal"
          @confrim="reloadPage"> 
        </ReportAddModal>
    </main>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import MidCategoryAddModal from "./components/MidCategoryAddModal.vue";
import SpecialConditionAddModal from "./components/SpecialConditionAddModal.vue";
import ReportAddModal from "./components/ReportAddModal.vue";

export default {
  name: "CoverageCategory",
  mixins: [commonMixin],
  components: {
    MidCategoryAddModal,
    SpecialConditionAddModal,
    ReportAddModal,
  },
  data() {
    return {
      midCategoryAddModalOpen: false,
      specialConditionAddModalOpen: false,
      reportAddModalOpen: false,
      reload: false,
    };
  },
  methods: {
    /**打開新增保障群組Modal*/
    openMidCategoryAddModal() {
      this.panelOpen("midCategoryAddModalOpen");
      this.reload = false;
    },
    /**關閉新增保障群組Modal*/
    closeMidCategoryAddModal() {
      this.panelClose("midCategoryAddModalOpen");
      this.reload = false;
    },
    /**新增完保障群組後重新讀取頁面**/
    reloadPage() {
      this.reload = true;
      this.midCategoryAddModalOpen && this.panelClose("midCategoryAddModalOpen");
      this.specialConditionAddModalOpen && this.panelClose("specialConditionAddModalOpen");
      this.reportAddModalOpen && this.panelClose("reportAddModalOpen");
    },
    openSpecialConditionAddModal() {
      this.panelOpen("specialConditionAddModalOpen");
      this.reload = false;
    },
    closeSpecialConditionAddModal() {
      this.panelClose("specialConditionAddModalOpen");
      this.reload = false;
    },
    openReportAddModal() {
      this.panelOpen("reportAddModalOpen");
      this.reload = false;
    },
    closeReportAddModal() {
      this.panelClose("reportAddModalOpen");
      this.reload = false;
    },
  },
};
</script>

<style scoped>
</style>
